<template>
  <div class="maintenanceTypes">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
<!--      <el-form-item label="名称" label-width="40px">-->
<!--        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.name" placeholder="请输入"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="编码">-->
<!--        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.code" placeholder="请输入"></el-input>-->
<!--      </el-form-item>-->
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button type="warning" @click="addItem">新增<i class="el-icon-plus el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="name"
            label="类型名称">
        </el-table-column>
        <el-table-column
            prop="code"
            label="类型编号">
        </el-table-column>
        <el-table-column
            prop="note"
            label="备注">
        </el-table-column>
        <el-table-column
            prop="cycle"
            align="center"
            label="保养周期(天)">
        </el-table-column>
        <el-table-column
            prop="address"
            fixed="right"
            width="150"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="editorClick(scope.row)">编辑</el-button>
            <!--            <el-button type="text" size="medium" @click="deleteClick(scope.row.id)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
<!--    &lt;!&ndash; 分页 &ndash;&gt;-->
<!--    <div style="margin-top: 20px">-->
<!--      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'-->
<!--                  @handleCurrentChange='handleCurrentChange'></Pagination>-->
<!--    </div>-->
    <el-dialog
        :title="modelTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  class="demo-ruleForm">
        <el-form-item label="类型名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="类型编号" prop="code">
          <el-input v-model="ruleForm.code" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="ruleForm.note" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="保养周期(天)">
          <el-input v-model="ruleForm.cycle" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";

export default {
  name: "maintenanceTypes",
  data() {
    return {
      tableData: [],
      searchForm: {
        name: '',
        code: '',
        parentCode: '',
      },
      modelTitle: '新增维护类型',
      dialogVisible: false,
      ruleForm: {
        address: '',
        corporate: '',
        license: '',
        corporateIdCard: '',
        email: '',
        phone: '',
        name: '',
        code: '',
        note: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入类型名称', trigger: 'blur'},
        ],
        code: [
          {required: true, message: '请输入类型编号', trigger: 'blur'},
        ],
      },
      areaId: '',
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
    }
  },
  components: {
    //someComponent
    Pagination,
  },
  methods: {
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.searchForm = {
        name: '',
        code: '',
        parentCode: ''
      }
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    addItem() {
      this.modelTitle = '新增维护类型'
      this.ruleForm = {}
      this.dialogVisible = true
    },
    editorClick(row) {
      this.modelTitle = '编辑维护类型'
      this.areaId = row.id
      this.ruleForm = {
        ...row
      }
      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            ...this.ruleForm,
          }
          if (this.modelTitle === '编辑维护类型') {
            this.axios
                .put("api/MaintainType?id=" + this.areaId, data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible=false
              this.init()
            })
          } else {
            this.axios
                  .post("api/MaintainType", data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible=false
              this.init()
            })
          }
        } else {
          return false;
        }
      });
    },
    // deleteClick(flag) {
    //     let data = {
    //       id: flag.id
    //     }
    //     this.axios
    //         .put("api/GroupPrivilege//api/Area", {params:data}).then((res) => {
    //       this.$message({
    //         message: '操作成功',
    //         type: 'success'
    //       });
    //     }).finally(error=>{
    //       this.init()
    //     })
    // },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },

    // list
    init() {
      let data = {
        name: this.searchForm.name,
        code: this.searchForm.code,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("api/MaintainType", {params: data})
          .then((res) => {
            this.tableData = res.list
            // this.tableData.forEach(item => {
            //   switch (item.level) {
            //     case 1:
            //       item.levelName = '国家'
            //       break;
            //     case 2:
            //       item.levelName = '省'
            //       break;
            //     case 3:
            //       item.levelName = '市'
            //       break;
            //     case 4:
            //       item.levelName = '县或者区'
            //       break;
            //   }
            // })
            this.total = res.count
          })
    }
  },
  mounted() {
    //
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.maintenanceTypes {
}
</style>